<template>
  <div
    class=""
    style="position: relative;">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <div v-else>
      <div
        class=""
        v-if="programSteps && programSteps.length">
        <div class="columns is-gapless has-background-reserved has-text-white is-marginless">
          <div class="column is-narrow is-w50p"></div>
          <div class="column columns is-padding">
            <div class="column is-3 is-margin-right">
              <div class="is-margin-bottom-xxsmall">
                <r-label
                  :is-required="false"
                  :label="'Montant total TTC attendu'"
                  :for-id="''"
                  class="has-text-white"></r-label>
              </div>
              <div class="field has-addons">
                <p class="control is-expanded">
                  <input
                    class="input has-text-right is-borderless has-text-weight-bold"
                    type="text"
                    placeholder=""
                    id="passage-adv4-total-percu-ttc"
                    :value="adv.is_furniture_adf ? totalAmount : totalAmount - furnituresPrice"
                    readonly>
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
              <div
                v-if="furnituresPrice"
                class="is-padding-top-xxsmall is-relative is-size-6">
                <i class="is-padding-left-xlarge is-margin-left-xsmall is-size-7">Inclure prix mobilier : {{ furnituresPrice | round(2) }} € TTC</i>
                <div
                  class="column columns is-column is-gapless is-space-between is-marginless checkbox_custom">
                  <r-label
                    label=""
                    :is-required="false"></r-label>
                  <div class="">
                    <input
                      id="is_furniture_adf"
                      type="checkbox"
                      name="is_furniture_adf"
                      class="switch is-success is-rounded is-small"
                      @change="$store.commit('modifyCurrentAdv', { key: `is_furniture_adf`, value: adv.is_furniture_adf })"
                      v-model="adv.is_furniture_adf">
                    <label for="is_furniture_adf">
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3 is-margin-right">
              <div class="is-margin-bottom-xxsmall">
                <r-label
                  :is-required="false"
                  :label="'Total TTC Percu'"
                  :for-id="''"
                  class="has-text-white"></r-label>
              </div>
              <div class="field has-addons">
                <p class="control is-expanded">
                  <input
                    class="input has-text-right is-borderless has-text-weight-bold"
                    type="text"
                    placeholder=""
                    id="passage-adv4-total-percu-ttc"
                    :value="totalPercu"
                    readonly>
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3 is-margin-right">
              <div class="is-margin-bottom-xxsmall">
                <r-label
                  :is-required="false"
                  :label="'Total TTC restant dû'"
                  :for-id="''"
                  class="has-text-white"></r-label>
              </div>
              <div class="field has-addons">
                <p class="control is-expanded">
                  <input
                    v-if="adv.is_furniture_adf"
                    class="input has-text-right is-borderless has-text-weight-bold"
                    type="text"
                    placeholder=""
                    id="passage-adv4-total-du-ttc"
                    :value="totalDu | round(2)"
                    readonly>
                  <input
                    v-else
                    class="input has-text-right is-borderless has-text-weight-bold"
                    type="text"
                    placeholder=""
                    id="passage-adv4-total-du-ttc"
                    :value="totalDu - furnituresPrice | round(2)"
                    readonly>
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xxsmall is-padding-right-xxsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isAdmin && isPromoteur"
          class="notification is-warning is-marginless is-min-height-75 is-flex">
          <div class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
            <b class="is-uppercase">Étape d'appel de fond : </b><span>Les différentes étapes d'appels de fonds se paramètrent au niveau de la fiche programme dans l'onglet "appel de fond".</span>
            <br>
            <router-link
              :to="{name: 'ProgramEdit', params: {id: program.pk}, query: {panel: 'APPEL_DE_FOND', check: 1 }}"
              class="is-underline is-uppercase">
              Vous pouvez
              éditer et activer les appels de fonds uniquement pour les étapes validées au niveau de la fiche programme.
            </router-link>
          </div>
        </div>

        <div
          v-for="(step, idx) in advSteps"
          :key="idx"
          :id="'e' + step.construction_step.uuid">
          <appel-de-fonds-item
            :source="adv"
            :furniture-price="furnituresPrice"
            :idx="idx"
            :lre-list="lreList"
            :to-open="toOpen"
            :step="step"
            @getAppelDeFondLre="getAppelDeFondLre">
          </appel-de-fonds-item>
        </div>
      </div>
      <div
        v-else
        class="is-padding has-background-white">
        <div>Aucune étape présente dans la fiche du programme.</div>
        <br>
        <router-link
          :to="{name: 'ProgramEdit', params: {id: program.pk}}"
          class="button is-primary">
          Fiche programme
        </router-link>
      </div>
      <!-- adv comment -->
      <div
        v-if="isAdmin && isPromoteur"
        class="has-background-white is-border-top">
        <div class="row-width-actions-bar columns is-gapless is-marginless">
          <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase title is-6">Commentaire appel de fond</span>
          </div>
          <div class="column is-narrow is-border-left">
          </div>
        </div>
        <template v-if="openComment">
          <div
            v-if="!openMentionCommentAdvWysi && comment_adv"
            @click="openWysiwyg"
            class="vadDiscussion is-border-top"
            style="cursor: pointer;">
            <div
              class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div
                class="content"
                v-if="isAdmin && comment_adv"
                v-html="comment_adv"></div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div class="">
                  <button
                    @click="openWysiwyg"
                    class="is-min-height-full">
                    <span class="icon is-small"><i class="fal fa-edit"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="is-border-top columns is-gapless">
            <div class="column">
              <wysiwyg-editor
                :light="true"
                :tooltip-top="true"
                :model="comment_adv"
                @change="val => comment_adv = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button
                  @click="patchCommentAdv()"
                  type="button"
                  class="button"
                  :class="[(baseCommentAdv !== comment_adv) ? 'is-success' : 'is-info']"
                  :disabled="(baseCommentAdv === comment_adv)">
                  <span class="icon is-small">
                    <i
                      v-if="loadComment"
                      class="fas fa-spinner fa-spin"></i>
                    <i
                      v-else
                      class="fal fa-save"></i>
                  </span>
                </button>
              </div>
              <div class="">
                <button
                  :disabled="!baseCommentAdv"
                  type="button"
                  :class="{'actionsOnRow-btn--hoverIsDanger': comment_adv}"
                  @click="comment_adv?openCommentWysi = false:null; comment_adv = baseCommentAdv">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
        class="has-background-white is-border-top is-margin-top-small">
        <div class="row-width-actions-bar columns is-gapless is-marginless">
          <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase title is-6">Commentaire</span>
          </div>
          <div class="column is-narrow is-border-left">
            <button
              class="page-header-btn is-small is-square"
              @click="openComment = !openComment">
              <span
                class="icon is-size-4">
                <i
                  v-if="!openComment"
                  class="fal fa-chevron-down"></i>
                <i
                  v-else
                  class="fal fa-chevron-up"></i>
              </span>
            </button>
          </div>
        </div>
        <template v-if="openComment">
          <div
            v-if="!openCommentWysi && comment"
            @click="openWysiwyg"
            class="vadDiscussion is-border-top"
            style="cursor: pointer;">
            <div
              class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div
                class="content"
                v-if="isAdmin && comment"
                v-html="comment"></div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div class="">
                  <button
                    @click="openWysiwyg"
                    class="is-min-height-full">
                    <span class="icon is-small"><i class="fal fa-edit"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="is-border-top columns is-gapless">
            <div class="column">
              <wysiwyg-editor
                :light="true"
                :tooltip-top="true"
                :model="comment"
                @change="val => comment = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button
                  @click="patchComment()"
                  type="button"
                  class="button"
                  :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                  :disabled="(baseComment === comment)">
                  <span class="icon is-small">
                    <i
                      v-if="loadComment"
                      class="fas fa-spinner fa-spin"></i>
                    <i
                      v-else
                      class="fal fa-save"></i>
                  </span>
                </button>
              </div>
              <div class="">
                <button
                  :disabled="!baseComment"
                  type="button"
                  :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                  @click="comment?openCommentWysi = false:null; comment = baseComment">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Adv } from '@/mixins'
import { bus, EVENTS } from '@/bus'

export default {
  name: 'AppelDeFonds',
  components: {
    AppelDeFondsItem: () => import('./AppelDeFondsItem')
  },
  mixins: [Adv],
  data () {
    return {
      lreList: [],
      toOpen: null,
      loading: false,
      advSteps: []
    }
  },
  computed: {
    /**
      * return program contruction steps
      * @returns {object}
      */
    programSteps () {
      return this.program.construction_steps
    },
    /**
      * total amount
      * @returns {number}
      */
    totalAmount () {
      if (this.adv && this.adv.sale_price_ttc) {
        return this.adv.sale_price_ttc
      } else {
        return null
      }
    },
    /**
      * total amount
      * @returns {number}
      */
    furnituresPrice () {
      if (this.lot && this.lot.furnitures && this.lot.furnitures.length) {
        let total = 0
        return this.lot.furnitures.reduce((a, b) => a + b.sale_price_ttc, total)
      } else {
        return null
      }
    },
    /**
      * total percu
      * @returns {number}
      */
    totalPercu () {
      let result = this.advSteps.reduce((a, b) => {
        if (b.construction_step.is_valid) {
          return a + Number(b.amount_received)
        } else return a
      }, 0)
      return result
    },
    /**
      * total du
      * @returns {number}
      */
    totalDu () {
      return this.adv.sale_price_ttc - this.totalPercu
    }
  },
  watch: {
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'RECOMMENDED_MANAGEMENT') {
          if (params.requestElem.adv_pk === this.advPk && params.from === 'adf') {
            let idx = this.lreList.findIndex(x => {
              return x.details.buyer === results.details.buyer && x.details.construction_step_uuid === results.details.construction_step_uuid
            })
            if (idx >= 0) {
              this.lreList.splice(idx, 1, results)
            } else {
              this.lreList.push(results)
            }
          }
        }
      }
    }
  },
  created () {
    this.advSteps = this.adv.construction_steps.slice()
    this.getAppelDeFondLre()
    bus.$on(EVENTS.RESERVATION_LRE_UPDATED, (data) => {
      for (let lre of this.lreList) {
        if (lre.lre_id === data.lre_id) {
          this.getAppelDeFondLre()
        }
      }
    })
  },
  methods: {
    /**
      * get lre of adf
      */
    async getAppelDeFondLre () {
      try {
        let { data } = await this.$api.axios.get('lre', {
          params: {
            reservation: this.advPk
          }
        })
        this.lreList = data.items
      } catch (err) {

      }
    }
  }
}
</script>

<style lang="sass" scoped>
.checkbox_custom
  position: absolute
  top: -10px
  left: -7px
</style>
